import Message from "@wielink-application/shared/js/helpers/Message";
import Ajax from "@wielink-application/shared/js/helpers/Ajax";
import Alert from "@wielink/datatables/Alert";
import Form from "@wielink-application/shared/js/helpers/Form";
import filterObject from "@wielink-application/shared/js/helpers/filterObject";
import prepareFormDefaults from "@wielink-application/shared/js/helpers/prepareFormDefaults";
import getValuesByKey from "@wielink-application/shared/js/helpers/getValuesByKey";
import Copy from "@wielink-application/shared/js/helpers/Copy";

const Helpers = {
	'Message': new Message(),
	'Alert': new Alert(),
	'Ajax': new Ajax(),
	'Form': new Form(),
    'Copy': new Copy(),
    'filterObject': filterObject,
    'prepareFormDefaults': prepareFormDefaults,
	'getValuesByKey': getValuesByKey,
}

export default Helpers
